
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faTimes as falTimes,
    } from '@fortawesome/pro-light-svg-icons/faTimes';

    export default {
        name: 'FeedbackModal',

        components: {
            FontAwesomeIcon,
        },

        data() {
            return {
                loading: true,
                isOpen: true,
                icons: {
                    falTimes,
                },
            };
        },

        created() {
            this.openModal();

            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.back();

                next(false);
            });

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard();
            });
        },

        beforeDestroy() {
            this.closeModal();
        },

        mounted() {
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },

        methods: {
            back() {
                this.closeModal();
            },

            close() {
                this.$emit('close');
            },

            openModal() {
                this.isOpen = true;
            },

            closeModal() {
                this.isOpen = false;
            },

            scripts() {
                return [
                    {
                        innerHTML: '(function(h,o,t,j,a,r){\n' +
                            'h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n' +
                            'h._hjSettings={hjid:1187539,hjsv:6};\n' +
                            'a=o.getElementsByTagName("head")[0];\n' +
                            'r=o.createElement("script");r.async=1;\n' +
                            'r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n' +
                            'a.appendChild(r);\n' +
                            '})(window,document,"https://static.hotjar.com/c/hotjar-",".js?sv=");',
                    },
                ];
            },
        },

        head() {
            return {
                script: this.scripts(),
            };
        },
    };
